export default __webpack_public_path__ + "static/media/rotatephone.0eb0da31.png";